import Joi from 'joi';

import { normalizeFeatureItemValue } from '../../../../functions/normalize-feature-item-value.function';
import { FeatureItemValueTypeEnum } from '../../../base/enums/feature-item-value-type.enum';
import { FeatureItemValueNormalizeError } from '../../../base/errors/feature-item-value-normalize.error';
import { VehicleCategoryFeatureItemTypeEnum } from '../../enums/vehicle-category-feature-item-type.enum';

/**
 * Schema for record validation.
 * @description This schema is used to validate the record properties when creating or updating the record.
 * `value` is type-aware via sibling `valueType` and is coerced to the string form stored in the DB.
 */
export const vehicleCategoryFeatureItemSchema = () =>
  Joi.object({
    id: Joi.number().optional(),
    uuid: Joi.string().required().messages({
      'any.required': 'validations|vehicle-category-feature-item-uuid|required',
    }),
    key: Joi.string().required().messages({
      'any.required': 'validations|vehicle-category-feature-item-key|required',
    }),
    title: Joi.string().required().messages({
      'any.required':
        'validations|vehicle-category-feature-item-title|required',
    }),
    subTitle: Joi.string().allow(null, '').optional(),
    description: Joi.string().allow(null, '').optional(),
    value: Joi.any()
      .allow(null, '')
      .optional()
      .custom((value, helpers) => {
        const valueType = helpers.state.ancestors[0]?.valueType as
          | FeatureItemValueTypeEnum
          | null
          | undefined;
        try {
          return normalizeFeatureItemValue(value, valueType);
        } catch (error) {
          if (error instanceof FeatureItemValueNormalizeError) {
            return helpers.error('any.custom', {
              message: error.message,
            });
          }
          throw error;
        }
      }),
    valueType: Joi.string()
      .valid(...Object.values(FeatureItemValueTypeEnum))
      .optional(),
    type: Joi.string()
      .valid(...Object.values(VehicleCategoryFeatureItemTypeEnum))
      .required()
      .messages({
        'any.required':
          'validations|vehicle-category-feature-item-type|required',
        'any.only':
          'validations|vehicle-category-feature-item-type|invalid-value',
      }),
    isVisible: Joi.boolean().optional(),
  })
    // Ignore extra fields
    .unknown();
